import { useRoute, useRouter } from '#imports'

import {
  landingReviewsAPI,
  productReviewsAPI,
  reviewsAPI,
  sellerReviewsAPI,
} from '@backmarket/http-api'
import { getMerchantShop } from '@backmarket/http-api/src/api-specs-navigation-experience/merchant-shop/merchant-shop'

import { PRODUCT } from '~/scopes/product-core/route-names'
import { ROUTES as PRODUCT_LIST_ROUTES } from '~/scopes/product-list/route-names'
import { useLinkBooster } from '~/scopes/seo/composables/useLinkBooster'

import { ROUTES } from '../../route-names'

export function useRequests() {
  const route = useRoute()
  const router = useRouter()
  const { fetchLinkBoosters } = useLinkBooster()

  switch (route.name) {
    case PRODUCT.MASTER_PP:
    case PRODUCT.HOME:
      return {
        ...productReviewsAPI,
        headers: { 'BM-Page-Name': route.name },
        hasAIReviewsSummary: true,
      }

    case PRODUCT_LIST_ROUTES.PRODUCT_LIST:
      return {
        ...landingReviewsAPI,
        getSeoLinks: () =>
          fetchLinkBoosters({
            sourceUrl: router.resolve({
              name: PRODUCT_LIST_ROUTES.PRODUCT_LIST,
              params: route.params,
            }).href,
            listType: 'plp_linkboosters',
          }),
      }
    case PRODUCT_LIST_ROUTES.SELLER_PRODUCT_LIST:
      return {
        getReviews: sellerReviewsAPI.getReviews,
      }
    case ROUTES.PAGES.MERCHANT:
      return {
        ...sellerReviewsAPI,
        // TODO Use dedicated service to request the title once it has been created
        getTitle: getMerchantShop,
      }

    case ROUTES.PAGES.ALL:
      return reviewsAPI

    default:
      return undefined
  }
}
